// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bad-request-banner_wrapper__1fZJP{flex:1 1 auto;min-width:0;margin:0 16px}.bad-request-banner_oneLine__Z1Az1{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
exports.locals = {
	"wrapper": "bad-request-banner_wrapper__1fZJP",
	"oneLine": "bad-request-banner_oneLine__Z1Az1"
};
module.exports = exports;
